import { Status, type AsyncState } from '@essent/common';
import { createReducer, on } from '@ngrx/store';

import {
  clearTimeslots,
  loadTimeslots,
  loadTimeslotsError,
  receivedTimeslotsForDay,
  setTimeslotDay,
} from './get-timeslots.actions';

export const sustainabilityTimeslotsId = 'timeslots';

export interface Timeslot {
  id: string;
  start: string;
  end: string;
}

export type TimeslotMapping = { [key: string]: Timeslot[] };

export type SustainabilityTimeslotsState = {
  selectedDay: string;
  timeslots: AsyncState<TimeslotMapping>;
};

export const initialSustainabilityTimeslotsState = {
  selectedDay: '',
  timeslots: { status: Status.IDLE },
};

export const sustainabilityTimeslotsReducer =
  createReducer<SustainabilityTimeslotsState>(
    initialSustainabilityTimeslotsState,
    on(setTimeslotDay, (state, param) => ({
      ...state,
      selectedDay: param.day,
    })),
    on(loadTimeslots, (state) => ({
      ...state,
      timeslots: { status: Status.PENDING },
    })),
    on(clearTimeslots, () => initialSustainabilityTimeslotsState),
    on(
      receivedTimeslotsForDay,
      (state, params): SustainabilityTimeslotsState => {
        const timeslots: TimeslotMapping = state.timeslots.data ?? {};
        timeslots[params.day] = params.timeslots;
        return {
          ...state,
          timeslots: { status: Status.SUCCESS, data: timeslots },
        };
      }
    ),
    on(loadTimeslotsError, (state) => ({
      ...state,
      timeslots: { status: Status.ERROR },
    }))
  );
